import { Bell, BellOff } from "lucide-react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { useAppDispatch } from "../../app/hooks";
import { MessagesChannel } from "../../features/messages/models/MessagesChannel";
import { MessageThread } from "../../features/messages/models/MessageThread";
import { setThreadMuted } from "../../features/messages/slice-extensions/messages-slice-extension";

interface MuteThreadButtonProps {
  channel: MessagesChannel;
  thread: MessageThread;
}

/** The reader's own mute: no email nudge and no nav-badge count for this thread. */
const MuteThreadButton = ({ channel, thread }: MuteThreadButtonProps) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const [busy, setBusy] = useState(false);
  const label = thread.isMuted ? t("messages.unmute") : t("messages.mute");
  const Icon = thread.isMuted ? Bell : BellOff;

  const toggle = async () => {
    setBusy(true);
    const result = await dispatch(setThreadMuted({ channel, threadId: thread.id, muted: !thread.isMuted }));
    setBusy(false);
    if (setThreadMuted.rejected.match(result)) toast.error(t("messages.muteFailed"));
  };

  return (
    <button
      type="button"
      className="btn btn-text shrink-0"
      onClick={toggle}
      disabled={busy}
      aria-pressed={thread.isMuted}
      aria-label={label}
    >
      <Icon size={16} aria-hidden="true" />
      <span className="hidden sm:inline">{label}</span>
    </button>
  );
};

export default MuteThreadButton;
